<div adaptToolbarContent>
    <a [routerLink]="personalDashboardLink$ | async"
       adaptButton="dashboardLink"
       adaptTooltip="Go to personal dashboard"></a>
</div>

<adapt-configuration-page-base [configGroups]="configGroups"
                               configTitle="My Configuration"
                               (selectedItemChange)="selectedItem = $event">
    @if (selectedItem?.area === ConfigArea.AccountSecurity) {
        <adapt-configure-personal-account-security [configItem]="selectedItem"></adapt-configure-personal-account-security>
    }
    @if (selectedItem?.area === ConfigArea.Kanban) {
        <adapt-configure-personal-kanban [configItem]="selectedItem"></adapt-configure-personal-kanban>
    }
    @if (selectedItem?.area === ConfigArea.CalendarIntegration) {
        <adapt-configure-calendar-integration [configItem]="selectedItem"
                                              [personalConfig]="true"></adapt-configure-calendar-integration>
    }
    @if (selectedItem?.area === ConfigArea.Notifications) {
        <adapt-configure-personal-notifications [configItem]="selectedItem"></adapt-configure-personal-notifications>
    }
    @if (selectedItem?.area === ConfigArea.Theme) {
        <adapt-configure-personal-theme [configItem]="selectedItem"></adapt-configure-personal-theme>
    }
</adapt-configuration-page-base>
